export default __webpack_public_path__ + "static/media/fanclash.8a167d50.png";